import { MutableRefObject, ReactNode } from 'react'
import classnames from 'classnames'
import cxs from 'cxs'

import getColor from '~/lib/getColor'
import getGenericDataId from '~/lib/getGenericDataId'

// The number `0` with no unit is a valid CSS length, see:
//   https://www.w3.org/TR/CSS2/syndata.html#length-units
// Though it might be inappropriate/avoidable in certain contexts, if it is
// valid CSS, we should allow it.
const isTruthyOrZero = (value?: number | string) => value || value === 0

type TextPropsType = {
    children?: ReactNode
    className?: string
    cursor?: string
    color?: string
    ['data-test-target']?: string
    element?: any
    fontWeight?:
        | number
        | '-moz-initial'
        | 'inherit'
        | 'initial'
        | 'revert'
        | 'unset'
        | 'bold'
        | 'normal'
        | 'bolder'
        | 'lighter'
    fontSize?: string | number
    lineHeight?: string | number
    name?: string
    placement?: string
    ref?: MutableRefObject<any>
    role?: string
    style?: { [key: string]: any }
    text?: string
    userSelect?:
        | '-moz-initial'
        | 'inherit'
        | 'initial'
        | 'revert'
        | 'unset'
        | 'text'
        | 'element'
        | 'auto'
        | 'none'
        | '-moz-none'
        | 'all'
        | 'contain'
}

export default function Text(props: TextPropsType) {
    const {
        className,
        color,
        fontWeight,
        fontSize,
        cursor,
        text,
        children,
        userSelect,
        lineHeight,
        element: Elem = 'span',
        ...passThroughProps
    } = props

    if (!(text || children)) {
        return null
    }

    const _className = classnames([
        className,
        isTruthyOrZero(color) && cxs({ color: getColor(color) }),
        isTruthyOrZero(cursor) && cxs({ cursor }),
        isTruthyOrZero(fontWeight) && cxs({ fontWeight }),
        isTruthyOrZero(fontSize) && cxs({ fontSize }),
        isTruthyOrZero(userSelect) && cxs({ userSelect }),
        isTruthyOrZero(lineHeight) && cxs({ lineHeight }),
    ])

    const dataId = getGenericDataId(_className)

    return (
        <Elem className={_className} {...passThroughProps} data-id={dataId}>
            {text || children}
        </Elem>
    )
}
